"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrangeLabels = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
function arrangeLabels(labels, viewportHeight) {
    const leftLabels = [];
    const rightLabels = [];
    labels.forEach(label => {
        const { position, orientation } = label;
        const labelHeight = 50;
        const isLeft = orientation === bridge_schema_1.LabelOrientation.Left;
        const currentLabels = isLeft ? leftLabels : rightLabels;
        let y = adjustYPosition(currentLabels, position.y * viewportHeight, labelHeight);
        // Check if we reached the bottom and need to find a top position
        if (y + labelHeight > viewportHeight) {
            y = findTopAvailablePosition(currentLabels, labelHeight, viewportHeight);
        }
        // Ensure the label stays within the viewport
        y = Math.min(y, viewportHeight - labelHeight);
        label.position.y = y / viewportHeight;
        // Store the label's new position
        currentLabels.push(label);
    });
    return [...leftLabels, ...rightLabels];
}
exports.arrangeLabels = arrangeLabels;
// Adjust the y-position based on existing labels to avoid overlap
function adjustYPosition(currentLabels, proposedY, labelHeight) {
    let adjustedY = proposedY;
    for (const label of currentLabels) {
        if (Math.abs(adjustedY - label.position.y) < labelHeight) {
            adjustedY = label.position.y + labelHeight + 10; // Adjust to avoid overlap
        }
    }
    return adjustedY;
}
// Helper function to locate the first available top position
function findTopAvailablePosition(labels, labelHeight, viewportHeight) {
    const sortedLabels = [...labels].sort((a, b) => a.position.y - b.position.y);
    const gaps = [];
    for (let i = 0; i < sortedLabels.length; i++) {
        const gap = i === sortedLabels.length - 1
            ? viewportHeight - sortedLabels[i].position.y
            : sortedLabels[i + 1].position.y - sortedLabels[i].position.y;
        if (gap >= labelHeight * 0.25) {
            // Small gap found, add to the list of gaps
            gaps.push({
                start: sortedLabels[i].position.y + labelHeight * 0.25,
                end: i === sortedLabels.length - 1
                    ? viewportHeight
                    : sortedLabels[i + 1].position.y,
            });
        }
    }
    if (gaps.length === 0) {
        return 50; // If no suitable gap is found, return the top of the viewport
    }
    // Select a random gap
    const randomGap = gaps[Math.floor(Math.random() * gaps.length)]; //NOSONAR
    // Return a random position within the selected gap
    return (randomGap.start +
        Math.random() * (randomGap.end - randomGap.start - labelHeight) //NOSONAR
    );
}
